import React from 'react';

import GridContainer from '@jumbo/components/GridContainer';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FileUploader from './FileUploader';

const useStyles = makeStyles(_ => ({
  cardContainer: {
    marginTop: 10,
  },
}));

const MediaContainer = () => {
  const classes = useStyles();
  return (
    <GridContainer>
      <Grid item xs={12}>
        <div className={classes.cardContainer}>
          <FileUploader />
        </div>
      </Grid>
    </GridContainer>
  );
};

export default MediaContainer;
